module.exports = __webpack_public_path__ + "static/media/03-Washington.a77ddaa1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/03-Washington.png
// module id = 1036
// module chunks = 0